import { render, staticRenderFns } from "./CardDialogFinish.vue?vue&type=template&id=40c238ba&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./card-dialog.component.ts?vue&type=script&lang=ts&"
export * from "./card-dialog.component.ts?vue&type=script&lang=ts&"
import style0 from "./CardDialogFinish.vue?vue&type=style&index=0&id=40c238ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c238ba",
  null
  
)

export default component.exports